import $ from 'jquery';
import axios from 'axios';

$(function () {
    const loginForm = $('#login-form');
    const errorContainer = $('.error-message-container');

    if (loginForm.length > 0) {
        loginForm.on('submit', function (e) {
            e.preventDefault();
            const barcode = $(this).find('input[name="barcode"]').val();
            const pin = $(this).find('input[name="pin"]').val();

            axios.post(loginForm.attr('action'), {barcode: barcode, pin: pin}).then(({data}) => {
                var d = new Date();
                d.setTime(d.getTime() + 12*60*60*1000);

                document.cookie = `CMLPROXY=CML_User_Valid;expires=${d.toUTCString()};path=/`;
                window.location = loginForm.data('external-url');
            }).catch((err) => {
                let msg = err.response.data.error;

                errorContainer.removeClass('uk-hidden');
                errorContainer.find('.error-message-content').text(msg);
            });
        });
    }
});